import { FC, useEffect, useState } from "react";
import { useLogeMembers } from "../api/user-api";
import { GameTabs } from "../components/dss/GameTabs";
import GaltonBoard from "../components/dss/GaltonBoard";
import { Skeleton } from "../components/dss/Skeleton";
import { LogeMember } from "../types/entities";

const GaltonBoardPage: FC = () => {
  const { data: members, isLoading } = useLogeMembers();
  const [roster, setRoster] = useState<LogeMember[]>([]);

  useEffect(() => {
    const filtered = (members ?? []).filter((m) => m.emoji);
    const shuffled = [...filtered].sort(() => Math.random() - 0.5);
    setRoster(shuffled);
  }, [members]);

  return (
    <div className="flex-1 flex flex-col min-h-0 pb-4">
      <GameTabs active="lod" className="mt-2 mb-2.5" />
      <div className="flex-1 min-h-0">
        {isLoading ? (
          <Skeleton className="w-full h-full rounded-lg" />
        ) : roster.length < 2 ? (
          <div className="flex-1 h-full flex items-center justify-center text-center font-mono text-[11px] text-ink3 px-6">
            Der skal være mindst 2 medlemmer på listen for at trække lod.
          </div>
        ) : (
          <GaltonBoard members={roster} />
        )}
      </div>
    </div>
  );
};

export default GaltonBoardPage;
